// import { useState } from 'react';
// import './Contact.scss';
// import axios from 'axios';
// import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
// import EmailIcon from '@mui/icons-material/Email';
// import DateRangeIcon from '@mui/icons-material/DateRange';
// import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     Phone: '',
//     Email: '',
//     Services: '',
//     date: '',
//   });


//   const [showPopup, setShowPopup] = useState(false);
//   const [resultData, setResultData] = useState(null);

//   const handleChange = (field, value) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//   };






// const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     // Step 1: Send appointment details to create a payment order
//     const response = await axios.post('/api/payment/create-order', formData);
//     const { orderId, razorpayKey } = response.data;

//     // Step 2: Launch Razorpay checkout with that orderId
//     const options = {
//       key: razorpayKey,
//       amount: formData.amount * 100, // if amount is dynamic
//       currency: "INR",
//       name: "Astrology Booking",
//       description: "Appointment Payment",
//       order_id: orderId,
//       handler: async function (response) {
//         // Step 3: Confirm payment to backend
//         const verifyRes = await axios.post('/api/payment/verify', {
//           ...response,        // payment_id, order_id, signature
//           formData            // appointment details
//         });

//         if (verifyRes.data.success) {
//           alert(" Payment successful and appointment booked!");
//         } else {
//           alert(" Payment failed. Try again.");
//         }
//       },
//       prefill: {
//         name: formData.firstName + " " + formData.lastName,
//         email: formData.Email,
//         contact: formData.Phone,
//       },
//       theme: {
//         color: "#3399cc",
//       },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   } catch (error) {
//     console.error(error);
//     alert("Error initiating payment");
//   }
// };



















//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   const payload = { ...formData };

//   //   try {
//   //     // Step 1: Send data to DB
//   //     const postResponse = await axios.post('YOUR_API_ENDPOINT', payload);

//   //     // Step 2: Fetch the saved data from DB (simulate or real)
//   //     const getResponse = await axios.get('YOUR_API_GET_ENDPOINT'); // Adjust based on backend

//   //     // Assume response.data contains saved info
//   //     setResultData(getResponse.data);
//   //     setShowPopup(true);
//   //   } catch (error) {
//   //     console.error("Error sending/receiving data:", error);
//   //     alert("Something went wrong. Please try again.");
//   //   }
//   // };


  

//   const handleClosePopup = () => {
//     setShowPopup(false);
//   };

//   const handleConfirmAndRedirect = () => {
//     // Simulate payment step (or real integration)
//     window.location.href = "https://rzp.io/rzp/aVoYCQ0";
//   };
  

//   return (
//     <div className="contact-footer" id='contact'>
//       <div className="contact__content">
//         <p>APPOINTMENT</p>
//         <h1>LET'S MEET WITH OUR TEAM</h1>
//       </div>

//       <form className="form" onSubmit={handleSubmit}>
// <div className="form-group">
//   <label className="label-with-icon">
//     <DriveFileRenameOutlineRoundedIcon className="icon" />
//     <span>FIRST NAME*</span>
//   </label>
//   <input
//     value={formData.firstName}
//     type="text"
//     placeholder="Your First Name"
//     onChange={(e) => handleChange('firstName', e.target.value)}
//     required
//   />
// </div>

// <div className="form-group">
//   <label className="label-with-icon">
//     <DriveFileRenameOutlineRoundedIcon className="icon" />
//     <span>LAST NAME*</span>
//   </label>
//   <input
//     value={formData.lastName}
//     type="text"
//     placeholder="Your Last Name"
//     onChange={(e) => handleChange('lastName', e.target.value)}
//     required
//   />
// </div>

// <div className="form-group">
//   <label className="label-with-icon">
//     <LocalPhoneIcon className="icon" />
//     <span>YOUR PHONE*</span>
//   </label>
//   <input
//     value={formData.Phone}
//     type="tel"
//     placeholder="Your Phone"
//     onChange={(e) => handleChange('Phone', e.target.value)}
//     required
//   />
// </div>

// <div className="form-group">
//   <label className="label-with-icon">
//     <EmailIcon className="icon" />
//     <span>YOUR EMAIL*</span>
//   </label>
//   <input
//     value={formData.Email}
//     type="email"
//     placeholder="Your Email"
//     onChange={(e) => handleChange('Email', e.target.value)}
//     required
//   />
// </div>

// <div className="form-group">
//   <label className="label-with-icon">
//     <ManageAccountsOutlinedIcon className="icon" />
//     <span>SERVICES*</span>
//   </label>
//   <select
//     value={formData.Services}
//     onChange={(e) => handleChange('Services', e.target.value)}
//     required
//   >
//     <option value="" disabled>Select a service</option>
//     <option value="Panchang">Kundli (Birth Chart)</option>
//     <option value="Calendar">Horoscope Matching</option>
//     <option value="Muhurat">Paid Services</option>
//     <option value="Vrat">Numerology Calculator</option>
//     <option value="Jyotish">Gochar Phal (Transit Report)</option>
//     <option value="Planet">Baby Name Suggestion</option>
//     <option value="Numerology">Today's Rahukaal</option>
//     <option value="Festivals">Kaal Sarp Dosha</option>
//   </select>
// </div>

// <div className="form-group">
//   <label className="label-with-icon">
//     <DateRangeIcon className="icon" />
//     <span>DATE*</span>
//   </label>
//   <input
//     value={formData.date}
//     type="date"
//     onChange={(e) => handleChange('date', e.target.value)}
//     required
//   />
// </div>

// <button type="submit">Proceed to Pay</button>

//       </form>

//       {/* Popup after POST + GET */}
//       {showPopup && resultData && (
//         <div className="popup-overlay">
//           <div className="popup">
//             <h2>Confirm Appointment Details</h2>
//             <ul>
//               <li><strong>First Name:</strong> {resultData.firstName}</li>
//               <li><strong>Last Name:</strong> {resultData.lastName}</li>
//               <li><strong>Phone:</strong> {resultData.Phone}</li>
//               <li><strong>Email:</strong> {resultData.Email}</li>
//               <li><strong>Service:</strong> {resultData.Services}</li>
//               <li><strong>Date:</strong> {resultData.date}</li>
//             </ul>

//             <div className="popup-buttons">
//               <button onClick={handleConfirmAndRedirect}>Confirm & Pay</button>
//               <button onClick={handleClosePopup}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Contact;


import { useState } from "react";
import "./Contact.scss";
import axios from "axios";
import city from "../../city.json";

/* ================= SERVICE CONFIG ================= */
const SERVICES = [
  { id: "kundli", name: "Kundli (Birth Chart)", type: "FREE" },
  { id: "matching", name: "Horoscope Matching", type: "FREE" },
  { id: "numerology", name: "Numerology Calculator", type: "FREE" },
  { id: "rahukaal", name: "Today's Rahukaal", type: "FREE" },
  { id: "kaalsarp", name: "Kaal Sarp Dosha", type: "FREE" },
  {
    id: "consultation",
    name: "Astrology Consultation",
    type: "PAID",
    amount: 499,
  },
];

const Contact = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  /* ================= FORM DATA ================= */
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    tob: "",
    place: "",
    appointmentDate: "",
  });

  /* ================= LOCATION AUTOCOMPLETE ================= */
  const [suggestions, setSuggestions] = useState([]);

  const handleChange = (field, value) => {
    setFormData((p) => ({ ...p, [field]: value }));
  };

  const handlePlaceChange = (e) => {
    const value = e.target.value;
    handleChange("place", value);

    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 5));
    } else {
      setSuggestions([]);
    }
  };

  const handleSelectPlace = (cityName) => {
    handleChange("place", cityName);
    setSuggestions([]);
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("Please wait...");

    try {
      if (selectedService.type === "FREE") {
        await axios.post("/api/appointments/free", {
          ...formData,
          service: selectedService.name,
        });
        setStatus("✅ Appointment booked successfully!");
      }

      if (selectedService.type === "PAID") {
        setStatus("Redirecting to payment gateway...");
        setTimeout(async () => {
          await axios.post("/api/payment/confirm", {
            ...formData,
            service: selectedService.name,
            amount: selectedService.amount,
          });
          setStatus("✅ Payment successful! Appointment confirmed.");
          setLoading(false);
        }, 2000);
        return;
      }
    } catch (err) {
      console.error(err);
      setStatus("❌ Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="contact-wrapper"id='contact'>
      <h1 className="title">Book an Appointment</h1>

      {/* ================= SERVICE TILES ================= */}
      {!selectedService && (
        <div className="services-grid">
          {SERVICES.map((service) => (
            <div
              key={service.id}
              className="service-card"
              onClick={() => setSelectedService(service)}
            >
              <span className={`badge ${service.type === "FREE" ? "free" : "paid"}`}>
                {service.type === "FREE" ? "FREE" : `₹${service.amount}`}
              </span>
              <h3>{service.name}</h3>
            </div>
          ))}
        </div>
      )}

      {/* ================= FORM ================= */}
      {selectedService && (
        <form className="form-card" onSubmit={handleSubmit}>
          {/* Selected Service */}
          <div className="selected-service">
            <span>Selected Service</span>
            <strong>
              {selectedService.name}
              {selectedService.type === "PAID" &&
                ` (₹${selectedService.amount})`}
            </strong>
          </div>

          {/* Basic Info */}
          <input
            placeholder="Full Name"
            required
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />

          <input
            placeholder="Email"
            type="email"
            required
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />

          <input
            placeholder="Phone"
            required
            value={formData.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
          />

          {/* DOB */}
          <label className="field-label">Date of Birth</label>
          <input
            type="date"
            required
            value={formData.dob}
            onChange={(e) => handleChange("dob", e.target.value)}
          />

          {/* TOB */}
          <label className="field-label">Time of Birth</label>
          <input
            type="time"
            required
            value={formData.tob}
            onChange={(e) => handleChange("tob", e.target.value)}
          />

          {/* Place Selector */}
          <label className="field-label">Place of Birth</label>
          <div className="place-input">
            <input
              type="text"
              placeholder="Enter city"
              value={formData.place}
              onChange={handlePlaceChange}
              required
            />
            {suggestions.length > 0 && (
              <ul className="dropdown">
                {suggestions.map((c, i) => (
                  <li key={i} onClick={() => handleSelectPlace(c.city)}>
                    {c.city}, {c.state}, {c.country}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Appointment Date */}
          <label className="field-label">Appointment Date</label>
          <input
            type="date"
            required
            min={new Date().toISOString().split("T")[0]}
            value={formData.appointmentDate}
            onChange={(e) => handleChange("appointmentDate", e.target.value)}
          />

          <button disabled={loading}>
            {loading
              ? "Please wait..."
              : selectedService.type === "PAID"
              ? "Proceed to Pay"
              : "Submit"}
          </button>

          <button
            type="button"
            className="back-btn"
            onClick={() => {
              setSelectedService(null);
              setStatus("");
            }}
          >
            ← Back to Services
          </button>

          {status && <p className="status">{status}</p>}
        </form>
      )}
    </div>
  );
};

export default Contact;

